<div class="modal-header">
  <h4 class="modal-title">Activity Record</h4>
  <button type="button" class="close" aria-label="Close" (click)="bsModalRef.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <h3> Add activity log for {{activityLog.targetedType}}</h3>

  <form [formGroup]="activityLogForm">
    <div class="form-inline">
      <div class="btn-group" ngbRadioGroup name="type" formControlName="type">
        <label ngbButtonLabel class="btn btn-primary"
               [ngClass]="{'button--primary-bordered': activityLogForm.get('type').value === 'done'}">
          <input ngbButton type="radio" [value]="'todo'" hidden>
          ToDO
        </label>
        <label ngbButtonLabel class="btn btn-primary"
               [ngClass]="{'button--primary-bordered': activityLogForm.get('type').value === 'todo'}">
          <input ngbButton type="radio" [value]="'done'" hidden>
          Done
        </label>
      </div>
    </div>
    <div>
      Company
      <ng-select [items]="activityLog.company.data"
                 [placeholder]="'Select company ...'" ngDefaultControl
                 class="autocomplete input-inline--multi input-inline--multi"
                 [closeOnSelect]="true"
                 [bindLabel]="'name'"
                 (change)="loadDataFor('user')"
                 formControlName="company">
      </ng-select>
    </div>
    <div>
      User
      <ng-select [items]="activityLog.user.data"
                 [placeholder]="'Select user ...'" ngDefaultControl
                 class="autocomplete input-inline--multi input-inline--multi"
                 [closeOnSelect]="true"
                 (change)="loadDataFor('project')"
                 formControlName="user">
        <ng-template ng-label-tmp let-item="item">
          <span >{{ item.first_name + ' ' + item.last_name }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
          <span >{{ item.first_name + ' ' + item.last_name }}</span>
        </ng-template>
      </ng-select>
    </div>
    <div>
      Project
      <ng-select [items]="activityLog.project.data"
                 [placeholder]="'Select project ...'" ngDefaultControl
                 class="autocomplete input-inline--multi input-inline--multi"
                 [closeOnSelect]="true"
                 [bindLabel]="'name'"
                 formControlName="project">
      </ng-select>
    </div>
    <div>
      Activity Type
      <ng-select [items]="activityTypes"
                 [placeholder]="'Select activity type ...'" ngDefaultControl
                 class="autocomplete input-inline--multi input-inline--multi"
                 [closeOnSelect]="true"
                 [bindLabel]="'name'"
                 formControlName="activityType">
      </ng-select>
    </div>
    <div>
      Assignee
      <ng-select class="autocomplete autocomplete--single input-inline--multi"
                 [items]="admins" [closeOnSelect]="true"
                 [bindLabel]="'name'"
                 [placeholder]="'assign to admin...'" ngDefaultControl
                 formControlName="assignee">
      </ng-select>
    </div>
    <div>
      <span *ngIf="activityLogForm.get('type').value === 'todo'">Due Date</span>
      <span *ngIf="activityLogForm.get('type').value === 'done'">Completion Date</span>
      <input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
             placeholder="Date Time" class="form-control" formControlName="dueDate">
      <owl-date-time #dt2></owl-date-time>
    </div>
    <div class="form-group">
      <label for="comment" class="control-label">Comment</label>
      <div class="col-sm-9">
        <textarea formControlName="comment" name="comment" class="form-control"
                  id="comment" placeholder="Add your notes..."></textarea>
      </div>
    </div>


    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="submitActivityLog()"
              [disabled]="activityLogForm.invalid">
        Save
      </button>
      <button type="button" class="btn btn-default" (click)="bsModalRef.close()">Cancel</button>
    </div>
  </form>
</div>
